<template>
  <modal :modal-key="'resubscribe-game-sms'" :class-style="'modal--welcomeback'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_resubscribe_game_sms_you_are_not }}</h1>
      <img :src="getTranslations.project_config_modal_img" alt="">
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_resubscribe_game_sms_in_order_to }}
      <br><br>
      {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal,
      'project_config_resub_resubscribe_gamesms_modal') }}
    </template>
    <template slot="footer">
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  // modal_unsubscribe_newgame_store_SMS.html
  name: 'resubscribe-game-sms',
  components: {
    Modal,
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGameSms.vue